// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
=============== 
Food Menu
===============
*/

.menu {
    padding: 5rem 0;
}

.title {
    text-align: center;
    margin-bottom: 2rem;
}

.underline {
    width: 5rem;
    height: 0.25rem;
    background: var(--clr-gold);
    margin-left: auto;
    margin-right: auto;
}

.btn-container {
    margin-bottom: 4rem;
    display: flex;
    justify-content: center;
}

.filter-btn {
    background: transparent;
    border-color: transparent;
    font-size: 1rem;
    text-transform: capitalize;
    margin: 0 0.5rem;
    letter-spacing: 1px;
    padding: 0.375rem 0.75rem;
    color: var(--clr-gold);
    cursor: pointer;
    transition: var(--transition);
    border-radius: var(--radius);
}

.filter-btn:hover {
    background: var(--clr-gold);
    color: var(--clr-white);
}

.section-center {
    width: 90vw;
    margin: 0 auto;
    max-width: 1170px;
    display: grid;
    gap: 3rem 2rem;
    justify-items: center;
}

.menu-item {
    display: grid;
    gap: 1rem 2rem;
    max-width: 25rem;
}

.photo {
    object-fit: cover;
    height: 200px;
    width: 100%;
    border: 0.25rem solid var(--clr-gold);
    border-radius: var(--radius);
    display: block;
}

.item-info header {
    display: flex;
    justify-content: space-between;
    border-bottom: 0.5px dotted var(--clr-grey-5);
}

.item-info h4 {
    margin-bottom: 0.5rem;
}

.price {
    color: var(--clr-gold);
}

.item-text {
    margin-bottom: 0;
    padding-top: 1rem;
}

@media screen and (min-width: 768px) {
    .menu-item {
        grid-template-columns: 225px 1fr;
        gap: 0 1.25rem;
        max-width: 40rem;
    }
    .photo {
        height: 175px;
    }
}

@media screen and (min-width: 1200px) {
    .section-center {
        width: 95vw;
        grid-template-columns: 1fr 1fr;
    }
    .photo {
        height: 150px;
    }
}`, "",{"version":3,"sources":["webpack://./src/foodmenu/foodmenu.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,qCAAqC;IACrC,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,6CAA6C;AACjD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,gCAAgC;QAChC,cAAc;QACd,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,8BAA8B;IAClC;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":["/*\r\n=============== \r\nFood Menu\r\n===============\r\n*/\r\n\r\n.menu {\r\n    padding: 5rem 0;\r\n}\r\n\r\n.title {\r\n    text-align: center;\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.underline {\r\n    width: 5rem;\r\n    height: 0.25rem;\r\n    background: var(--clr-gold);\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n.btn-container {\r\n    margin-bottom: 4rem;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.filter-btn {\r\n    background: transparent;\r\n    border-color: transparent;\r\n    font-size: 1rem;\r\n    text-transform: capitalize;\r\n    margin: 0 0.5rem;\r\n    letter-spacing: 1px;\r\n    padding: 0.375rem 0.75rem;\r\n    color: var(--clr-gold);\r\n    cursor: pointer;\r\n    transition: var(--transition);\r\n    border-radius: var(--radius);\r\n}\r\n\r\n.filter-btn:hover {\r\n    background: var(--clr-gold);\r\n    color: var(--clr-white);\r\n}\r\n\r\n.section-center {\r\n    width: 90vw;\r\n    margin: 0 auto;\r\n    max-width: 1170px;\r\n    display: grid;\r\n    gap: 3rem 2rem;\r\n    justify-items: center;\r\n}\r\n\r\n.menu-item {\r\n    display: grid;\r\n    gap: 1rem 2rem;\r\n    max-width: 25rem;\r\n}\r\n\r\n.photo {\r\n    object-fit: cover;\r\n    height: 200px;\r\n    width: 100%;\r\n    border: 0.25rem solid var(--clr-gold);\r\n    border-radius: var(--radius);\r\n    display: block;\r\n}\r\n\r\n.item-info header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    border-bottom: 0.5px dotted var(--clr-grey-5);\r\n}\r\n\r\n.item-info h4 {\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.price {\r\n    color: var(--clr-gold);\r\n}\r\n\r\n.item-text {\r\n    margin-bottom: 0;\r\n    padding-top: 1rem;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n    .menu-item {\r\n        grid-template-columns: 225px 1fr;\r\n        gap: 0 1.25rem;\r\n        max-width: 40rem;\r\n    }\r\n    .photo {\r\n        height: 175px;\r\n    }\r\n}\r\n\r\n@media screen and (min-width: 1200px) {\r\n    .section-center {\r\n        width: 95vw;\r\n        grid-template-columns: 1fr 1fr;\r\n    }\r\n    .photo {\r\n        height: 150px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
